import React from 'react';
import { Check } from 'lucide-react';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function ExteriorDetailingPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Exterior Car Detailing',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Thousand Oaks', 'Ventura County', 'Los Angeles'],
    description: 'Professional mobile exterior car detailing services including hand wash, clay bar treatment, wheel cleaning, and wax protection.'
  };
  return <ServicePageLayout title="Exterior Car Detailing in Los Angeles & Ventura County" subtitle="Protect your paint and restore a brilliant shine with our premium mobile exterior detailing services. We bring the ultimate wash and wax directly to you." metaDescription="Top-rated mobile exterior car detailing in Camarillo, Thousand Oaks, and Ventura County. Hand wash, clay bar, and ceramic wax protection. Call (818) 381-9905." schema={schema} data-id="element-371">
      <p data-id="element-372">
        Your vehicle's exterior faces a constant barrage of environmental
        hazards: UV rays, bird droppings, tree sap, road tar, and industrial
        fallout. Over time, these contaminants degrade your clear coat, leaving
        your paint looking dull and feeling rough. At Mike's Pro Detail, our{' '}
        <strong data-id="element-373">mobile exterior car detailing</strong> service is designed to
        safely remove these contaminants, restore a deep gloss, and apply
        durable protection. Whether you need car detailing in Camarillo,
        Thousand Oaks, or anywhere in Ventura County, our mobile unit provides a
        superior alternative to automated car washes that scratch and swirl your
        paint.
      </p>

      <h2 data-id="element-374">Our Exterior Detailing Process</h2>
      <p data-id="element-375">
        We utilize safe, scratch-free wash methods and premium products to
        ensure your vehicle looks its absolute best. Our exterior detailing
        package includes:
      </p>

      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-376">
        <li className="flex items-start" data-id="element-377">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-378" />
          <span data-id="element-379">
            <strong data-id="element-380">Two-Bucket Hand Wash:</strong> A meticulous hand wash using
            premium microfiber mitts and pH-neutral soap to safely lift dirt
            without inducing swirl marks.
          </span>
        </li>
        <li className="flex items-start" data-id="element-381">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-382" />
          <span data-id="element-383">
            <strong data-id="element-384">Deep Wheel & Tire Cleaning:</strong> We use specialized
            brushes and non-acidic cleaners to remove baked-on brake dust from
            wheel barrels, faces, and tires.
          </span>
        </li>
        <li className="flex items-start" data-id="element-385">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-386" />
          <span data-id="element-387">
            <strong data-id="element-388">Clay Bar Treatment:</strong> A crucial step that removes
            embedded contaminants (like overspray and rail dust) that washing
            alone cannot remove, leaving the paint smooth as glass.
          </span>
        </li>
        <li className="flex items-start" data-id="element-389">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-390" />
          <span data-id="element-391">
            <strong data-id="element-392">Bug & Tar Removal:</strong> Safe breakdown and removal of
            stubborn bug splatter and road tar from the front bumper and lower
            rocker panels.
          </span>
        </li>
        <li className="flex items-start" data-id="element-393">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-394" />
          <span data-id="element-395">
            <strong data-id="element-396">Premium Wax / Sealant Application:</strong> Application of a
            high-quality hybrid ceramic wax or polymer sealant to provide months
            of protection and intense water beading.
          </span>
        </li>
        <li className="flex items-start" data-id="element-397">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-398" />
          <span data-id="element-399">
            <strong data-id="element-400">Tire & Trim Dressing:</strong> Application of a no-sling,
            UV-blocking dressing to tires and faded exterior plastics to restore
            a rich, dark appearance.
          </span>
        </li>
      </ul>

      <h2 data-id="element-401">Why Exterior Detailing is Essential</h2>
      <p data-id="element-402">
        Regular exterior detailing is preventative maintenance for your
        vehicle's paint. The Southern California sun can quickly cause clear
        coat failure and oxidation if the paint is left unprotected. By
        regularly removing bonded contaminants through a clay bar treatment and
        applying a protective wax or sealant, you create a sacrificial barrier
        against the elements. This not only keeps your car looking stunning but
        also preserves its resale value and prevents costly paint repairs down
        the line.
      </p>

      <h2 data-id="element-403">The Premier Choice for Mobile Auto Detailing Camarillo CA</h2>
      <p data-id="element-404">
        When you search for "Mobile Detailing Ventura County" or need reliable
        service in Thousand Oaks, Mike's Pro Detail is the trusted choice. We
        bring our own spot-free water and electricity, meaning we can perform a
        flawless exterior detail in your driveway, at your office parking lot,
        or even at your apartment complex. We treat every vehicle as if it were
        our own, ensuring that every inch of your exterior receives the
        attention it deserves.
      </p>
    </ServicePageLayout>;
}